import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from '../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.adobeIntegration.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AdobeIntegration_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AdobeIntegration_DisplayText)
    ]
})
export class AdobeIntegrationLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_APIKey
    })
    public apiKey?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccountID
    })
    public accountId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_OrgID
    })
    public orgId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Exp
    })
    public exp?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_TenantId
    })
    public tenantId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_MetaScopes
    })
    public metaScopes?: string[] = ['ent_campaign_sdk', 'ent_adobeio_sdk', 'event_receiver_api', 'ent_gdpr_sdk'];

    @Metamodel.attribute({
        display: stringResources.ModelName_JournalEndpoint
    })
    public journalEndpoint?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_PrivateKeyContent,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public privateKeyContent?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
